<template>
  <el-dialog
    title="选择邀请人"
    :visible="currentVisible"
    :before-close="handleClose"
    width="80%"
  >
    <avue-crud
      :option="qcNameOption"
      :data="childQcData"
      :search.sync="search"
      @search-change="searchChange"
      ref="crud"
    >
      <template slot-scope="{ row, index }" slot="search">
        <section class="d-f">
          <span class="p-t-5">资源类型：</span>
          <div class="w-90">
            <el-select v-model="search.resource" clearable placeholder="请选择">
              <el-option
                v-for="item in search.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <span class="p-t-5 m-l-10">是否新人：</span>
          <div class="w-90">
            <el-select
              v-model="search.newPerson"
              clearable
              placeholder="请选择"
            >
              <el-option label="是" value="2"></el-option>
              <el-option label="否" value="1"></el-option>
            </el-select>
          </div>
        </section>
        <div class="el-form-item el-form-item--small l-h-32 m-l-10">
          <el-checkbox v-model="search.isProceed">
            未被占用
            <span class="f-s-12">（无进行中任务</span>
            ）
          </el-checkbox>
        </div>
      </template>
      <template slot="newPerson" slot-scope="scope">
        <span v-if="scope.row.newPerson === 2">是</span>
        <span v-if="scope.row.newPerson === 1">否</span>
      </template>
      <template slot="isProceed" slot-scope="scope">
        <span v-if="scope.row.isProceed === 1">是</span>
        <span v-if="scope.row.isProceed === 0">否</span>
      </template>
      <template slot-scope="{ row, index }" slot="menu">
        <!-- 后期如果人多了还会加上限制条件，所以代码先注释掉 -->
        <!-- <el-button :disabled="currentRow==0&&(row.taskNum<10 && row.userType=='兼职')" type="primary" size="mini" @click.stop="addTr(row,index)">添加</el-button> -->
        <el-button type="primary" size="mini" @click.stop="addTr(row, index)">
          添加
        </el-button>
      </template>
    </avue-crud>
  </el-dialog>
</template>

<script>
import { qcNameOption } from '@/const/crud/dot/qc';
import { listQC } from '@/api/dot/qc';
export default {
  props: [
    'visible', // 弹窗的触发逻辑，非显示状态
  ],
  data() {
    return {
      currentVisible: false,
      qcNameOption: qcNameOption,
      childQcData: [],
      search: {
        resource: '',
        options: [
          {
            value: '兼职',
            label: '兼职',
          },
          {
            value: '全职',
            label: '全职',
          },
          {
            value: '团队',
            label: '团队',
          },
          {
            value: '公司',
            label: '公司',
          },
        ],
        newPerson: '',
      },
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.getQcNameList();
      }
    },
  },
  methods: {
    getQcNameList() {},
  },
};
</script>
